import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      position="top-center"
      duration={3000}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-1000 group-[.toaster]:border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-900",
          actionButton: "group-[.toast]:bg-primary-500 group-[.toast]:text-gray-10",
          cancelButton: "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-1000",
          success: "!border-green-500 !bg-green-10 [&_[data-icon]]:!text-green-600",
          error: "!border-red-500 !bg-red-10 [&_[data-icon]]:!text-red-600",
          warning: "!border-yellow-500 !bg-yellow-10 [&_[data-icon]]:!text-yellow-600",
          info: "!border-blue-500 !bg-blue-10 [&_[data-icon]]:!text-blue-600",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
